import '../../css/EditTermsAndConditions.css'
import { useEffect, useState, useCallback } from "react"
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom'
import ErrorBoundary from '../../errorHandlers/ErrorBoundry';
import { useOrganizationContext } from '../../context/OrganizationContext';
import { getOrganizationKeyInLang, updateOrganizationKeyInLang } from '../../helpers/helperFunctions';
import { Text } from '../CreateContribution/formComponents/FormComponents'
import { useCustomTranslation } from '../../helpers/CustomTranslationsComps';
import { TextEditor } from '../common/TextEditor';
import { AdminApi } from '../../api/admin';

const EditTermsAndConditionsComponent = () => {
    const orgCtx = useOrganizationContext()
    const history = useHistory()
    const { i18n } = useTranslation()
    const { getTranslation } = useCustomTranslation(orgCtx?.organization?.id || '')
    const [termsAndConditions, setTermsAndConditions] = useState<string>("")
    const [previewContent, setPreviewContent] = useState<JSX.Element | null>(null)
    const [isPreview, setIsPreview] = useState<boolean>(false)
    const [isHtml, setIsHtml] = useState<boolean>(false)
    const [isNew, setIsNew] = useState<boolean>(false)

    useEffect(() => {
        if (orgCtx && orgCtx.organization) {

            if(isPreview) setIsPreview(false);

            setIsHtml(true);

            let language = i18n.language

            const tAndC = getOrganizationKeyInLang(orgCtx.organization, 'terms', language)

            setTermsAndConditions(tAndC)
        }
    }, []);

    const handleFormUpdate = (e: React.ChangeEvent<HTMLTextAreaElement>) => {    
        const newValue = e.target.value || "";

        setTermsAndConditions(newValue);

    }

    const handleSubmit = async () => {
        let language = i18n.language

        const resp = await AdminApi.handleTermsAndConditions(termsAndConditions, language, orgCtx?.organization?.id || '');

        if (!resp.message) {
            updateOrganizationKeyInLang(orgCtx!.organization!, 'terms', language, termsAndConditions);
        }
    }

    const handlePreview = () => {
        if (!orgCtx || !orgCtx.organization) return null

        if (isPreview) {
            setIsPreview(false);
            setIsHtml(true);
            return;
        }
        const preview = <div dangerouslySetInnerHTML={{ __html: termsAndConditions }} />
        
        setPreviewContent(preview);
        setIsPreview(true);
        setIsHtml(false);
    }

    return ( 
        <div className="edit-terms-and-conditions-container">
            <h1 className="edit-header">Edit Terms and Conditions</h1>

            {/* {isHtml ? <textarea className="edit-container-textarea" value={termsAndConditions} onChange={handleFormUpdate}></textarea> : null} */}
            {isHtml ? <div className="edit-container">
                
                <TextEditor
                    initialValue={ termsAndConditions }
                    onChange={(newValue: string) => { setTermsAndConditions(newValue) }}
                />
            </div> : null}  

            {isPreview ? <div className="edit-container"> {previewContent || ""} </div> : null}

            <div className="button-container">
                <button className="button" onClick={handleSubmit} style={{ backgroundColor: orgCtx?.organization?.color }}>
                    <span className="loader-btn__text">{getTranslation('GLOBAL.SAVE')}</span>
                </button>

                {/* <button className="button" onClick={handlePreview} style={{ backgroundColor: orgCtx?.organization?.color }}>
                    <span className="loader-btn__text">{isHtml ? getTranslation('Preview') : getTranslation('Raw text')}</span>
                </button> */}
            </div>
        </div>
    );
}

export const EditTermsAndConditions = ({ ...props }) => {
  const history = useHistory()
  if (props.environment === "prod") {
    return (
      <ErrorBoundary location="EditTermsAndConditionsTranslations" router={history}>
        <EditTermsAndConditionsComponent {...props} />
      </ErrorBoundary>
    )
  }
  return (
    <EditTermsAndConditionsComponent {...props} />
  )
}